import React, { useEffect, useState } from 'react';
import { createBrowserHistory } from 'history';
import { Router, Switch } from 'react-router-dom';
import MainLayout from './Layout/MainLayout';
import { ADMIN, CLIENTADMIN, LEARNER, userIsInRole } from './Services/AuthService';
import AdminRoutes from './Routes/AdminRoutes';
import ClientRoutes from './Routes/ClientRoutes';
import LearnerRoutes from './Routes/LearnerRoutes';
import ThemeContextProvider from './Infrastructure/Context/ThemeContext';
import { getThemeAsync } from './Services/ThemeService';
import Loading from './Shared/Loading';
import LogoutModal from './Shared/Account/LogoutModal';
import TSALogo from './Assets/TSALogo.png';
import TSAFavicon from './Assets/tsa-favicon.ico';
import { useAuthState } from './Services/AuthService';

const history = createBrowserHistory();

const Platform = () => {

    const defaultTheme = {
        primaryButtonColour: '#079fd0',
        secondaryButtonColour: '#0479a0',
        primaryNavColour: '#0b5f7a',
        secondaryNavColour: '#f5fbff',
        primaryNavFontColour: '#ffffff',
        secondaryNavFontColour: '#0f172a',
        iconColour: '#079fd0',
        sidebarIconColour: '#ffffff',
        logoUrl: TSALogo,
        loadingLogoUrl: TSALogo,
        faviconUrl: TSAFavicon
    };

    const [theme, setTheme] = useState(defaultTheme);
    const [loading, setLoading] = useState(true);
    const auth = useAuthState();

    const redirectToLogin = () => {
        if (window.location.pathname !== '/') {
            window.location.replace('/');
        }
    };

    useEffect(() => {
        if (!auth.isAuthenticated || !auth.user) {
            redirectToLogin();
            return;
        }

        getClientTheme();
        setTimeout(() => {
            setLoading(false);
        }, 2500)
    }, [auth.isAuthenticated, auth.user])

    const getClientTheme = async () => {
        console.log("Platform - Getting theme, user in localStorage:", window.localStorage.getItem("user"));

        try {
            let response = await getThemeAsync();
            console.log("Platform - Theme response:", response);

            if (response.success) {
                const resolvedTheme = { ...defaultTheme, ...response.config };
                setTheme(resolvedTheme)
                let link = document.querySelector("link[rel~='icon']");
                link.href = resolvedTheme.faviconUrl;
                if (auth.user?.firstName && auth.user?.lastName) {
                    document.title = auth.user.firstName + " " + auth.user.lastName + " | eLearning";
                }
            }
            else {
                console.log("Platform - Theme failed with response.success = false");
                console.log("Response:", response);
                // Don't log out the user just because theme failed
                setTheme(defaultTheme);
            }
        } catch (error) {
            console.error("Platform - Theme API threw an error:", error);
            console.error("Error response:", error.response);
            // Don't log out the user just because theme failed
            setTheme(defaultTheme);
        }
    }

    return (
        <>
            <Router history={history}>
                <ThemeContextProvider theme={theme}>
                    <LogoutModal />
                    {loading ?
                        <Loading />
                        :
                        <MainLayout>
                            <Switch>
                                {userIsInRole(ADMIN) && <AdminRoutes />}
                                {userIsInRole(CLIENTADMIN) && <ClientRoutes />}
                                {userIsInRole(LEARNER) && <LearnerRoutes />}
                            </Switch>
                        </MainLayout>
                    }
                </ThemeContextProvider>
            </Router>
        </>
    );
};

export default Platform;